import styled from 'styled-components';
import { CSVLink } from 'react-csv';

export const HiddenCSVLink = styled(CSVLink)`
  display: none;
`;
